// Generated by Melange

import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function Security(Props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: "Безопасность",
        className: "h4 lg:h2 text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: "Бухта очень заботится о сохранности данных пользователей. Наши системы постоянно проходят проверки и сертификации для обеспечения надежного хранения и избежания утечек информации.",
        className: "paragraph text-black-landing mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h6", {
                children: "Сертификат СТ РК ISO/IEC 27001-2015",
                className: "h6 text-black-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "PNG ･ 446 KB",
                className: "paragraph text-gray-landing mt-1"
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx("img", {
                  className: "cursor-pointer",
                  alt: "security",
                  src: StaticAsset.src("/static/images/security-certificate.png")
                }),
                className: "mt-6",
                href: StaticAsset.src("/static/images/security-certificate.png"),
                target: "_blank"
              })
            ],
            className: "w-full lg:w-[400px] bg-bg rounded-lg p-6 mt-6 lg:mt-10"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h6", {
                children: "Акт испытаний",
                className: "h6 text-black-landing min-h-[56px]"
              }),
              JsxRuntime.jsx("p", {
                children: "PNG ･ 446 KB",
                className: "paragraph text-gray-landing mt-1"
              }),
              JsxRuntime.jsx("a", {
                children: JsxRuntime.jsx("img", {
                  className: "cursor-pointer",
                  alt: "security",
                  src: StaticAsset.src("/static/images/security-certificate-2.png")
                }),
                className: "mt-6",
                href: StaticAsset.src("/static/images/security-certificate-2.png"),
                target: "_blank"
              })
            ],
            className: "w-full lg:w-[400px] bg-bg rounded-lg p-6 mt-6 lg:mt-10"
          })
        ],
        className: "flex gap-6"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsxs("p", {
        children: [
          "По вопросам сотрудничества и партнерства пишите на ",
          JsxRuntime.jsx("a", {
            children: "hello@buhta.com",
            className: "text-primary underline",
            href: "mailto:hello@buhta.com"
          })
        ],
        className: "paragraph-small lg:paragraph text-black-landing mt-6 lg:mt-10"
      })
    ],
    className: "pt-10 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = Security;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
